<script lang="ts">
  let { genreFingerprint }: { genreFingerprint: Record<string, number> | null } = $props();

  const dnaEntries = $derived(
    genreFingerprint
      ? Object.entries(genreFingerprint)
          .sort(([, a], [, b]) => b - a)
          .slice(0, 8)
      : [],
  );
</script>

{#if dnaEntries.length > 0}
  <div class="dna-section">
    <h2>Music DNA</h2>
    <div class="dna-bars">
      {#each dnaEntries as [genre, weight]}
        <div class="dna-row">
          <span class="dna-label">{genre}</span>
          <div class="dna-bar-bg">
            <div class="dna-bar-fill" style="width: {Math.min(weight, 100)}%"></div>
          </div>
          <span class="dna-pct">{Math.round(weight)}%</span>
        </div>
      {/each}
    </div>
  </div>
{/if}

<style>
  .dna-section {
    margin-top: 2rem;
  }
  .dna-section h2 {
    font-size: 1rem;
    margin-bottom: 0.75rem;
  }
  .dna-bars {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  .dna-row {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }
  .dna-label {
    font-size: 0.75rem;
    font-weight: 500;
    min-width: 6rem;
    color: var(--text-secondary);
    text-transform: capitalize;
  }
  .dna-bar-bg {
    flex: 1;
    height: 8px;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 4px;
    overflow: hidden;
  }
  .dna-bar-fill {
    height: 100%;
    border-radius: 4px;
    background: linear-gradient(90deg, var(--cyan), var(--purple));
    transition: width 0.4s ease;
  }
  .dna-pct {
    font-size: 0.75rem;
    font-weight: 600;
    color: var(--cyan);
    min-width: 2.5rem;
    text-align: right;
  }
</style>
